module.exports = __webpack_public_path__ + "static/media/pic_14.e7abf0f4.JPG";